import React, { useContext, Fragment, useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { Dashboards } from "../../../components/backgrounds/Dashboards";
import { Primary } from "../../../components/buttons/Primary";
import { SimulatorRenovar } from "../../../components/credits/SimulatorRenovar";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { CreditUserContext } from "../../../context/CreditUser/CreditUserContext";
import { HttpRequest } from "../../../services/httpRequest";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { SuccessAlert } from "../../../components/alerts/successAlert";
import moment from "moment";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { ModalRenovarCupo } from "../../../components/modals/modalRenovarcupo";
import { Spinner } from "../../../components/spinner/spinner_await";
import { returnToSignin } from "../../../utils/returnToSign";
import { useCredit } from "../../../context/creditContext";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { APIClient } from "../../../helpers/api_helper";
import { GET_AVAILABLE_REWARD } from "../../../helpers/url_helper";

const api = new APIClient();

export function ConfirmarPage() {
  const { disclosures, creditInfo, due } = useCredit();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { creditUser, updateCreditUser } = useContext(CreditUserContext);

  const [cupoDisponible, setCupoDisponible] = useState("");
  const [viewalert, setViewalert] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [messageModal, setMessageModal] = useState("");
  const [redirectModal, setRedirectModal] = useState("");
  const [isOpenSpinner, setIsOpenSpinner] = useState(false);
  const [rewardHistoryAvailable, setRewardHistoryAvailable] = useState();

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const loadInfoQuota = async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const getAvailableReward = async () => {
    try {
      let { data } = await api.get(
        GET_AVAILABLE_REWARD + localStorage.getItem("doc")
      );
      let availableReward = data?.data;
      return availableReward;
    } catch (error) {
      console.log(error);
      return {};
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsOpenSpinner(true);
    handleClearStateAlert();
    setMessageModal("");
    setIsOpenModal(false);
    setRedirectModal("");
    try {
      let creditData = creditUser;
      creditData.versionTarifas = "2";
      creditData.versionContrato = "2";
      creditData.status = "Solicitado";
      creditData.approvedDate = moment().format("DD/MM/YYYY");
      creditData.documento = state.doc;
      creditData.acceptanceDate = moment().format("DD/MM/YYYY");
      updateCreditUser(creditData);
      let payload = {
        creditInfo: creditData,
        doc: state.doc,
      };
      //console.log("lo que se envia para solicitar renovacion: ", creditUser);
      let response = await HttpRequest.renovarCredito(payload);
      await HttpRequest.registrarFechaAceptacion({
        acceptanceDate: moment().format("DD/MM/YYYY"),
        documento: creditUser.documento,
      });

      if (response.error && response.message?.code === "INVALIDQUOTA") {
        setIsOpenSpinner(false);
        handleOpenAlert(
          "error",
          `Lo sentimos. 
          no podemos procesar tu solicitud, hay un aumento inusual en tu cupo, por favor comunicate con el área de soporte para
          revisar a fondo, gracias por tu comprensión.`,
          true
        );
        return;
      }

      if (response.message.error === true) {
        handleOpenAlert(
          "error",
          "Ha ocurrido un error interno, por favor intente mas tarde.",
          true
        );
        setIsOpenSpinner(false);
        return;
      }

      setIsOpenSpinner(false);

      if (response.message.statusCredit === "APROBADO") {
        let credit_id = response.message.message?.credit_id;
        localStorage.setItem('credit_id', credit_id);
        updateCreditUser({
          ...creditUser,
          credit_id: credit_id,
          approvedQuota: cupoDisponible,
          documento: state.doc,
          acceptanceDate: moment().format("DD/MM/YYYY"),
          approvedDate: moment().format("DD/MM/YYYY"),
          status: "Solicitado",
          versionTarifas: "2",
          versionContrato: "2"
        });
        return navigate("/oferta", {
          state: { isRenovateCredit: true, doc: state?.doc ?? localStorage.getItem('doc'), credit_id: credit_id }
        })
      } else if (response.message.statusCredit === "RECHAZADO") {
        if (response.message?.motivo === "TIENE CREDITO VIGENTE") {
          setMessageModal(
            "Debes pagar el crédito que tienes actualmente para poder usar tu cupo de crédito."
          );
          setIsOpenModal(true);
          setRedirectModal("/pagar");
        } else {
          handleOpenAlert(
            "error",
            "Lo sentimos, su crédito ha sido rechazado",
            true
          );
        }
      }
    } catch (error) {
      console.log('Error :', error);
      alert("Ha ocurrido un error interno, por favor intente mas tarde.");
      return;
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadQuotaStatus = async () => {
      let quotaStatus = await loadInfoQuota();
      return quotaStatus;
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          let availableReward = await getAvailableReward();
          setRewardHistoryAvailable(availableReward);
          let cupo = await loadQuotaStatus();
          let cupoDisponible = 0;
          if (cupo && cupo.cupoUtilizado) {
            cupoDisponible = Number(cupo.cupoUtilizado) === 0 ? cupo.cupoAprobado : cupo.cupoDisponible;
          } else {
            cupoDisponible = cupo?.cupoDisponible;
          }
          setCupoDisponible(cupoDisponible);
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"3"}
          title={"Consultar cupo"}
          main={
            <>
              <div className="pt-10 mt-10 md:mt-0 pb-32 md:pb-0 bg-white md:bg-transparent rounded-t-3xl">
                <div className="md:mx-8 xl:mx-16 px-8 py-10 bg-white md:shadow-lg shadow-none rounded-2xl">
                  <div className="px-4">
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={100} />
                      <SkeletonDahsboard height={20} width={70} />
                    </div>
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={110} />
                      <SkeletonDahsboard height={20} width={70} />
                      <SkeletonDahsboard height={20} width={200} />
                      <SkeletonDahsboard height={30} width={40} />
                    </div>
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={100} />
                      <SkeletonDahsboard height={40} width={120} />
                    </div>
                    <div className="grid pt-6 justify-center">
                      <div className="flex gap-2 pt-8 justify-center">
                        <div className="pb-2 sm:pb-0">
                          <SkeletonDahsboard height={50} width={150} />
                        </div>
                      </div>
                      <div className="flex xl:hidden gap-2 text-sm pt-2">
                        <div className="grid justify-center w-full">
                          <div className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto">
                            <SkeletonDahsboard
                              variant={"circular"}
                              height={20}
                              width={20}
                            />
                          </div>
                          <SkeletonDahsboard height={15} width={60} />
                        </div>
                        <div className="grid justify-center w-full">
                          <div className="grid justify-center w-full">
                            <div className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto">
                              <SkeletonDahsboard
                                variant={"circular"}
                                height={20}
                                width={20}
                              />
                            </div>
                            <SkeletonDahsboard height={15} width={60} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}

      {isOpenModal ? (
        <ModalRenovarCupo
          isOpen={isOpenModal}
          messageDialog={messageModal}
          redirect={redirectModal}
        ></ModalRenovarCupo>
      ) : (
        <></>
      )}

      <DashboardMyCredit
        current={"3"}
        name={state?.name}
        balance={state?.amount}
        title={"Calcula tu crédito"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <>
            <div className="py-10 flex justify-center pb-32 md:pb-0">
              <div className="max-w-md md:mx-8 xl:mx-16 px-8 py-10 bg-white shadow-lg rounded-3xl">
                <SimulatorRenovar
                  title={"Confirma el monto."}
                  title2={"Elige la fecha de pago."}
                  maxAmn={Number(cupoDisponible)}
                  minAmn={200000}
                  step={10000}
                  default={parseInt(cupoDisponible)}
                  rewardHistoryAvailable={rewardHistoryAvailable}
                />
                {isOpenSpinner ? (
                  <Spinner sizeSpinner={80} colorSpinner={"#7e02fc"}></Spinner>
                ) : (
                  <div className="block xl:flex pt-6 justify-center">
                    <Link
                      to={"/oferta"}
                      state={{ isRenovateCredit: true, doc: state?.doc ?? localStorage.getItem('doc') }}
                      onClick={handleSubmit}
                    >
                      <Primary
                        text={"Continuar"}
                        icon={<ArrowLongRightIcon className="w-6 h-auto" />}
                      />
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </>
        }
      />
    </Fragment>
  );
}
